<template>
	<div class="position-relative">
		<div class="authentication-wrapper authentication-basic container-p-y p-4 p-sm-0">
			<div class="authentication-inner py-6" style="max-width: 600px;">
				<div class="card p-md-7 p-1">
					<div class="card-body mt-1 text-center">
						<i class="ri-checkbox-circle-line" style="font-size: 64px; color: var(--bs-success);"></i>
						<h4 class="mt-4">{{ $t('backgroundCheck.done.thanks') }}</h4>
						<p class="text-muted mt-3" style="font-size: 15px;">
							{{ $t('backgroundCheck.done.processing') }}<br>
							{{ $t('backgroundCheck.done.emailNotification') }}
						</p>
						<div class="alert alert-light mt-4 py-2 px-3" style="font-size: 13px;">
							<i class="ri-time-line me-1"></i> {{ $t('backgroundCheck.done.processingTime') }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import "@/assets/vendor/css/pages/page-auth.css";

export default {
	name: "BackgroundCheckDone",
};
</script>
